import { BadgeVariants } from '@quinyx/ui';

export const TASK_ID_IN_TEXT_PATTERN = /[a-f0-9]{24}/i;
export const TICKET_PATTERN = /^[A-Za-z][A-Za-z0-9]+-\d+$/;
export const MIN_REASON_LENGTH = 10;
export const DELETE_CONFIRM_WORD = 'DELETE';
export const NOT_FOUND_STATUS_CODE = 404;
export const TASK_MANAGEMENT_MODULE = 'TASK_MANAGEMENT';
export const EMPTY_VALUE = '—';

export const TASK_STATE = {
  DELETED: 'deleted',
  RECURRING: 'recurring',
  SCHEDULED: 'scheduled',
  DISTRIBUTED: 'distributed',
  NOT_SENT: 'notSent',
} as const;

export type TaskState = (typeof TASK_STATE)[keyof typeof TASK_STATE];

export const TASK_STATE_BADGE_VARIANT: Record<TaskState, BadgeVariants> = {
  deleted: 'notice',
  recurring: 'displayViolet',
  scheduled: 'info',
  distributed: 'positive',
  notSent: 'warning',
};
